module.exports = __webpack_public_path__ + "static/media/mn.e96c4c3e.webp";